import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { Navigate } from 'react-router-dom';
import moment from "moment";
import { ActionPlansContext } from "context/ActionPlansContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ImageList from "@mui/material/ImageList";
import { makeStyles } from "@mui/styles";
import UserService from "services/UserService";
import { postAction, getActionPlan, getActionRecommandation } from "services/ConfigServices";
import { CustomSelect, TextInput } from "components/Input/Index.js";
import SubmitButton from "components/CustomButtons/SubmitButton";
import { planActions } from "variables/planActions";
import { categoryData } from "variables/lists/action";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function AddActionDialog(props) {
  const { closeModal, setLoading, refetch } = props;

  const appContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = appContext;
  const [newAction, setNewAction] = useState({
    general: {
      name: "",
      category: "",
      description: "",
      code: "",
    },
  });
  const [groupsParent, setGroupsParent] = useState(
    actionPlans?.parameters?.general?.groups?.[0]
  );
  const [groups, setGroups] = useState([]);

  const [redirState, setRedirState] = useState(false);
  const [actionId, setActionId] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [actionrecommendations, setActionrecommendations] = useState("");
  const [actionrecommendation, setActionrecommendation] = useState("");



  useEffect(() => {
    if (
      newAction &&
      newAction.general &&
      newAction.general.name !== undefined &&
      newAction.general.category !== undefined &&
      newAction.general.description !== undefined &&
      newAction.general.code !== undefined
    ) {
      if (
        newAction?.general.name.length > 0 &&
        newAction?.general.category.length > 0 &&
        newAction?.general.description.length > 0 &&
        newAction?.general.code.length > 0 &&
        groups.length > 0
      ) {
        setButtonDisabled(false);
      } else {
        setButtonDisabled(true);
      }
    }
  }, [JSON.stringify(newAction), groups]);

  useEffect(() => {
    if (groupsParent > 0) {
      axios
        .get(
          getActionRecommandation(groupsParent),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          setActionrecommendations(res.data || []);
        });
    }
  }, [groupsParent]);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/actionplans/selectedplanaction/selectedaction/",
        state: {
          planActionId: actionPlans.id,
          planActionName: actionPlans.parameters.general.name,
          actionId,
          actionName: newAction.name,
        },
      }}
    />
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(e.target);
    setNewAction((prevState) => ({
      ...prevState,
      general: {
        ...prevState.general,
        [name]: value,
      }
    }));
  };

  const handleActionRecommandationsChange = (e) => {
    console.log(e.target.value);
    let recommendationobj = actionrecommendations.find((obj) => obj.id === e.target.value);
    console.log(recommendationobj);
    setNewAction((prevState) => ({
      ...prevState,
      general: {
        ...prevState.general,
        name: recommendationobj.name,
        code: recommendationobj.name,
        category: recommendationobj.parameters.general?.category,
        subcategory: recommendationobj.parameters.general?.subcategory || "",
        description: recommendationobj.parameters.general?.description || "",
      },
      details: {
        description: recommendationobj.parameters.details?.description || "",
        target: recommendationobj.parameters.details?.target || "",
        advantages: recommendationobj.parameters.details?.advantages || "",
        disadvantages: recommendationobj.parameters.details?.disadvantages || "",
        implemenation: recommendationobj.parameters.details?.implemenation || "",
        regulation: recommendationobj.parameters.details?.regulation || "",
      },
      recommendation: recommendationobj.parameters.recommendation || ""
    }));
    setActionrecommendation(e.target.value);
  };

  console.log(newAction);

  useEffect(() => {
    setNewAction((prevState) => (
      {
        ...prevState,
        general: {
          ...prevState.general,
          actionplan: actionPlans.id
        }
      }
    ));
    setGroups(actionPlans.parameters.general.groups[0]);
  }, [actionPlans]);

  let url = postAction();

  const handleSubmit = (event) => {
    createAction(event);
  };

  const createAction = async (event) => {
    console.log({ general: { ...newAction, groups: [groups] } });

    await axios
      .post(
        url,
        {
          ...newAction,
          general: {
            ...newAction.general,
            groups: [groups],
            status: "inprogress",
            lastupdate: moment().format("YYYY-MM-DD"),
            creationdate: moment().format("YYYY-MM-DD"),
            wantedstartdate: "",
            wantedenddate: "",
          },
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        console.log(res.data.id);
        setActionId(res.data.id);
        if (res.status == 200) {
          setNotification("success", "Action ajouté");
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
    setRedirState(true);
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={7}>
          {actionrecommendations ?
            <div>
              <CustomSelect
                inputTitle={"Préconisation"}
                selectValue={actionrecommendation}
                handleSelectValueChange={handleActionRecommandationsChange}
                data={actionrecommendations}
              /></div> : <></>
          }
          <TextInput
            inputTitle={planActions.actions.name}
            textInput={newAction.general?.name}
            handleTextInputChange={handleChange}
            name="name"
          />
          <TextInput
            inputTitle={planActions.actions.code}
            textInput={newAction.general?.code}
            handleTextInputChange={handleChange}
            name="code"
          />
          <TextInput
            inputTitle={planActions.actions.description}
            textInput={newAction.general?.description}
            handleTextInputChange={handleChange}
            name="description"
          />
          <CustomSelect
            inputTitle={planActions.actions.category}
            selectValue={newAction.general?.category}
            handleSelectValueChange={handleChange}
            data={categoryData}
            name="category"
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={5} lg={5}>
          <div className={classes.treeVisible}>
            <TreeLabel>Choix du périmètre</TreeLabel>
            <ImageList rowHeight={140} className={classes.gridList} cols={1}>
              <EmbeddedEntitesTree
                selectedIds={setGroups}
                userSelectedIds={groupsParent}
                multiSelect={false}
              />
            </ImageList>
          </div>
        </GridItem>

        <GridItem xs={12} sm={6} md={7} lg={7}>
          <SubmitButton
            buttonDisabled={buttonDisabled}
            handleSubmit={handleSubmit}
          >
            Ajouter
          </SubmitButton>
        </GridItem>
      </GridContainer>
      {redirecting}
    </>
  );
}

export default AddActionDialog;
